const BREAKPOINT = {
  TABLET: '768px',
  DESKTOP: '1200px'
}

export { BREAKPOINT }
